import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FileText, Loader2, Maximize2, Table } from 'lucide-react';
import { cn } from '../../lib/utils';
import { EnhancedMarkdown } from '../EnhancedMarkdown';
export function DocumentPreview(props) {
    const { title, kind, content, isStreaming = false, className, onExpand } = props;
    const Icon = kind === 'sheet' ? Table : FileText;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('w-full', className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "p-4 border rounded-t-2xl flex items-center justify-between bg-muted border-b-0",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-3 min-w-0",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-muted-foreground",
                                children: isStreaming ? /*#__PURE__*/ _jsx(Loader2, {
                                    className: "h-4 w-4 animate-spin"
                                }) : /*#__PURE__*/ _jsx(Icon, {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "font-medium truncate",
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        className: "p-2 rounded-md hover:bg-background/60 text-muted-foreground",
                        "aria-label": "Expand",
                        onClick: onExpand,
                        children: /*#__PURE__*/ _jsx(Maximize2, {
                            className: "h-4 w-4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "overflow-y-auto border rounded-b-2xl p-6 bg-background border-t-0",
                children: /*#__PURE__*/ _jsx(EnhancedMarkdown, {
                    content: content
                })
            })
        ]
    });
}
